import { render } from "./AddSubscriptionDialog.vue?vue&type=template&id=1856064b&scoped=true"
import script from "./AddSubscriptionDialog.vue?vue&type=script&lang=js"
export * from "./AddSubscriptionDialog.vue?vue&type=script&lang=js"

import "./AddSubscriptionDialog.vue?vue&type=style&index=0&id=1856064b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1856064b"]])

export default __exports__